
























import { Component, Vue } from 'vue-property-decorator'

@Component
export default class AppLoader extends Vue {
  // Code.
}
